import { VisibleSection } from "components/common/VisibleSection";
import { ONE, THREE } from "domain/aboutYourLoan";
import { RepaymentOption } from "domain/indicativeRepaymentOptions";
import {
  RepaymentHolidaysType,
  SelectedTreatmentsDetails,
} from "domain/selectedTreatments";
import { HideIfNoData } from "util/enhancer";
import { NullableField } from "util/extendedTypes";
import {
  CRHImportantInformation,
  CIRHImportantInformation,
  CIRHChoicesExplained,
  CIRHOptions,
  CRHChoicesExplained,
  CRHOptions,
  RepaymentHolidayOptions,
} from ".";

export type RHNoExtendTermActiveProps = {
  CRHTaken: number;
  CIRHTaken: number;
  repaymentOptions: RepaymentOption[];
  selectedTreatments: SelectedTreatmentsDetails;
  checked: boolean;
  onChange: (selectedTreatments: SelectedTreatmentsDetails) => void;
  onChecked: (checked: boolean) => void;
};

export const RHNoExtendTermActive = ({
  repaymentOptions,
  selectedTreatments,
  checked,
  onChange,
  onChecked,
  CRHTaken,
  CIRHTaken,
}: RHNoExtendTermActiveProps) => {
  const CRHVisible =
    selectedTreatments.selectedRHType ===
    RepaymentHolidaysType.CapitalRepaymentHoliday;
  const existingLoanDetails = selectedTreatments.existingLoanDetails;
  const ONE_OPTION_FLAG =
    existingLoanDetails != null
      ? existingLoanDetails.numberOfRepayments < 7
      : false;
  const CIRHVisible =
    selectedTreatments.selectedRHType ===
    RepaymentHolidaysType.CapitalIntersestRepaymentHoliday;
  const RHOptionsVisible = CRHTaken < THREE && CIRHTaken < ONE;
  return (
    <>
      <VisibleSection visible={RHOptionsVisible}>
        <RepaymentHolidayOptions
          selectedTreatments={selectedTreatments}
          onChange={onChange}
          onChecked={onChecked}
        />
        <VisibleSection visible={CRHVisible}>
          <br />
          <CRHChoicesExplained showSingleOption={ONE_OPTION_FLAG} />
          <CRHOptions
            repaymentOptions={repaymentOptions}
            selectedTreatments={selectedTreatments}
            onChange={onChange}
          />
          <CRHImportantInformation
            selectedTreatments={selectedTreatments}
            checked={checked}
            onChecked={onChecked}
          />
        </VisibleSection>
        <VisibleSection visible={CIRHVisible}>
          <br />
          <CIRHChoicesExplained showSingleOption={ONE_OPTION_FLAG} />
          <CIRHOptions
            repaymentOptions={repaymentOptions}
            selectedTreatments={selectedTreatments}
            onChange={onChange}
          />
          <CIRHImportantInformation
            selectedTreatments={selectedTreatments}
            checked={checked}
            onChecked={onChecked}
          />
        </VisibleSection>
      </VisibleSection>
      <VisibleSection visible={!RHOptionsVisible}>
        <VisibleSection visible={CRHTaken < THREE}>
          <br />
          <CRHChoicesExplained showSingleOption={ONE_OPTION_FLAG} />
          <CRHOptions
            repaymentOptions={repaymentOptions}
            selectedTreatments={selectedTreatments}
            onChange={onChange}
          />
          <CRHImportantInformation
            selectedTreatments={selectedTreatments}
            checked={checked}
            onChecked={onChecked}
          />
        </VisibleSection>
        <VisibleSection visible={CIRHTaken < ONE}>
          <br />
          <CIRHChoicesExplained showSingleOption={ONE_OPTION_FLAG} />
          <CIRHOptions
            repaymentOptions={repaymentOptions}
            selectedTreatments={selectedTreatments}
            onChange={onChange}
          />
          <CIRHImportantInformation
            selectedTreatments={selectedTreatments}
            checked={checked}
            onChecked={onChecked}
          />
        </VisibleSection>
      </VisibleSection>
    </>
  );
};

export const RHNoExtendTermActiveComponent = HideIfNoData<
  RHNoExtendTermActiveProps,
  NullableField<RHNoExtendTermActiveProps, "CRHTaken" | "CIRHTaken">
>((p) => false)(RHNoExtendTermActive);
